/* ============================================================
   Разбор внутренних ссылок витрины («#tournament/mlbb-women-2026»,
   «/news», полный URL сайта) — общая логика для deep-link при
   загрузке (FedApp) и для ссылок в уведомлениях (Notifications).
   ============================================================ */
import { useAppStore } from '../store';
import { useFedStore } from './store';

export const KNOWN_ROUTES = [
  'home', 'tournaments', 'tournament', 'news', 'article', 'winners', 'live',
  'about', 'partners', 'gallery', 'contacts', 'projects', 'project', 'regulations', 'auth',
  'admin', 'smm', 'profile', 'register', 'notifications', 'messenger', 'teams', 'team', 'privacy', 'terms',
  'notfound', 'jerebiovka',
];
const ALIAS = { login: 'auth', signup: 'auth', stream: 'live' };
export const TOUR_TABS = ['overview', 'reg', 'teams', 'bracket', 'groups', 'players', 'matches'];
export const ADMIN_TABS = ['info', 'live', 'teams', 'form', 'groups', 'bracket', 'players'];
export const ADMIN_SECTIONS = ['dash', 'tours', 'tourEdit', 'news', 'newsEdit', 'regs', 'inbox', 'sponsors', 'live', 'matches', 'docs', 'gallery', 'partners', 'projects', 'winners', 'team', 'users', 'notify', 'settings', 'more'];

/** Разобрать hash/путь ('tournament/mlbb-women-2026', '#live', '/news') —
    вернуть { target, sub } для известного роута витрины или null. */
export function parseFedRoute(raw) {
  const clean = String(raw || '').replace(/^#/, '').replace(/^\/+|\/+$/g, '');
  const [path, query = ''] = clean.split('?');
  const [seg, sub] = path.split('/');
  const target = ALIAS[seg] || (KNOWN_ROUTES.includes(seg) && seg);
  const joinCode = new URLSearchParams(query).get('join');
  const tourTab = new URLSearchParams(query).get('tab');
  const params = new URLSearchParams(query);
  return target ? { target, sub: sub ? decodeURIComponent(sub) : null, joinCode,
    ...(target === 'tournament' && TOUR_TABS.includes(tourTab) ? { tourTab } : {}),
    ...(target === 'admin' ? {
      adminSection: ADMIN_SECTIONS.includes(params.get('section')) ? params.get('section') : 'dash',
      adminEditId: params.get('edit') || null,
      adminTourTab: ADMIN_TABS.includes(tourTab) ? tourTab : 'info',
    } : {}),
  } : null;
}

/** Применить распознанный роут (route + tourId/articleId, если есть). */
export function goFedRoute({ target, sub, joinCode, tourTab, adminSection, adminEditId, adminTourTab }) {
  if (target === 'tournament' && sub) useFedStore.setState({
    tourId: sub,
    tourTab: tourTab || 'overview',
    teamJoinCode: '',
    ...(joinCode ? { tourTab: 'reg', teamJoinCode: joinCode.trim().toUpperCase().slice(0, 5) } : {}),
  });
  if (target === 'admin') useFedStore.setState({ adminSection: adminSection || 'dash', adminEditId: adminEditId || null, adminTourTab: adminTourTab || 'info' });
  if (target === 'article' && sub) useFedStore.setState({ articleId: sub });
  if (target === 'project' && sub) useFedStore.setState({ projectId: sub });
  if (target === 'messenger' && sub) useFedStore.setState({ messengerId: Number(sub) || null });
  useAppStore.getState().go(target);
}

/** Открыть ссылку из уведомления: свой адрес — переходом внутри витрины,
    чужой (Telegram-пост, трансляция и т.п.) — новой вкладкой. */
export function openNotificationLink(link) {
  if (!link) return;
  let raw = link;
  try {
    const url = new URL(link, window.location.origin);
    if (url.origin !== window.location.origin) {
      window.open(link, '_blank', 'noopener,noreferrer');
      return;
    }
    raw = url.hash || url.pathname;
  } catch (e) { /* не абсолютный URL — считаем внутренним путём/хэшем */ }

  const parsed = parseFedRoute(raw);
  if (!parsed) { window.open(link, '_blank', 'noopener,noreferrer'); return; }
  goFedRoute(parsed);
}
